/** Area row inside Table Service step */
export type AreaFormValue = {
  name: string;
  tableCount: string;
  prefix: string;
};

/** Form model for Table Service step */
export type TableServiceFormValue = {
  hasTableService: string;
  areas: AreaFormValue[];
  skipAreaConfig: boolean;
};

/** Fiscal data choice for a single brand in the Receipt step */
export type BrandFiscalFormValue = {
  brandUuid: string;
  brandName: string;
  useRegisteredData: string;
  legalName: string;
  rfc: string;
  fiscalAddress: string;
};

/** Form model for Receipt step */
export type ReceiptFormValue = {
  businessName: string;
  legalName: string;
  rfc: string;
  fiscalAddress: string;
  brands: BrandFiscalFormValue[];
};

/** Full onboarding wizard form model — managed by react-hook-form */
export type WizardFormValues = {
  restaurantType: string;
  tableService: TableServiceFormValue;
  cashRegister: string;
  tip: string;
  tax: string;
  receipt: ReceiptFormValue;
};

/** Default values for the wizard form */
export const WIZARD_FORM_DEFAULT_VALUES: WizardFormValues = {
  restaurantType: '',
  tableService: {
    hasTableService: '',
    areas: [],
    skipAreaConfig: false,
  },
  cashRegister: '',
  tip: '',
  tax: '',
  receipt: {
    businessName: '',
    legalName: '',
    rfc: '',
    fiscalAddress: '',
    brands: [],
  },
};
